import { Component, OnInit, Input, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { AppService } from 'app/main/services/app.service';
import { CartService } from 'app/main/services/cart.service';

@Component({
	selector: 'trip-package-cart-page',
	templateUrl: './shopping-cart.component.html',
	styleUrls: ['./shopping-cart.component.scss']
})
export class TripPackageShoppingCartPageComponent implements OnInit {

	@Input() cartItem: any;

	constructor(public appService: AppService, public cartService: CartService){}

	ngOnInit(): void {
		console.log(this.cartItem);
	}
}
